/**
 * 菜单配置 / Menu Configuration
 * 按角色定义导航菜单
 */

export const menuConfig = {
  // 管理员菜单
  ADMIN: [
    { path: '/admin/dashboard', title: '仪表盘', icon: '📊' },
    { path: '/admin/users', title: '用户管理', icon: '👥' },
    { path: '/admin/roles', title: '角色管理', icon: '🎭' },
    { path: '/admin/features', title: '功能管理', icon: '⚙️' },
    { path: '/admin/app-version', title: 'APP版本', icon: '📱' }
  ],

  // 批发商菜单
  WHOLESALER: [
    { path: '/wholesaler/home', title: '首页', icon: '🏠' },
    { path: '/wholesaler/product', title: '商品管理', icon: '📦' },
    { path: '/wholesaler/orders', title: '订单管理', icon: '📋' },
    { path: '/wholesaler/wholesale-price-list', title: '批发价', icon: '💰' },
    { path: '/wholesaler/order-on-behalf', title: '代客下单', icon: '🛒' },
    { path: '/wholesaler/driver-management', title: '配送管理', icon: '🚚' },
    { path: '/wholesaler/purchase-return-list', title: '退货单', icon: '↩️' },
    { path: '/wholesaler/purchase-list', title: '进货单', icon: '📥' },
    { path: '/wholesaler/business-report', title: '报表', icon: '📊' },
    { path: '/my-profile', title: '我的', icon: '👤' }
  ],

  // 档口菜单
  STALL: [
    { path: '/stall/home', title: '首页', icon: '🏠' },
    { path: '/stall/products', title: '商品市场', icon: '📦' },
    { path: '/stall/orders', title: '我的订单', icon: '📋' },
    { path: '/stall/scan-qr', title: '扫码下单', icon: '📱' },
    { path: '/stall/profile', title: '我的', icon: '👤' }
  ],

  // 配送员菜单
  COURIER: [
    { path: '/delivery/grab-hall', title: '抢单大厅', icon: '🏪' },
    { path: '/delivery/orders', title: '订单记录', icon: '📋' },
    { path: '/delivery/profile', title: '个人中心', icon: '👤' }
  ],

  // 通用菜单（所有角色都有）
  COMMON: [
    { path: '/Profile', title: '个人中心', icon: '👤' },
    { path: '/Settings', title: '设置', icon: '⚙️' }
  ]
};

/**
 * 根据角色获取菜单
 * @param {string} role - 角色标识
 * @returns {Array} 菜单数组
 */
export function getMenuByRole(role) {
  const roleMenus = menuConfig[role] || [];
  const commonMenus = menuConfig.COMMON || [];
  
  return [...roleMenus, ...commonMenus];
}

/**
 * 根据用户身份获取菜单
 * @param {string} identity - 用户身份 (ADMIN/WHOLESALER/STALL/COURIER)
 * @returns {Array} 菜单数组
 */
export function getMenuByIdentity(identity) {
  const identityUpper = identity?.toUpperCase();
  return getMenuByRole(identityUpper);
}

export default menuConfig;
